module.exports = __webpack_public_path__ + "static/donate-0b2916a1c6167e75517ae0ffdb969420.mp4";